<template>
    <Drawer :mask-closable="true" @on-close="reset()" class="demo-drawer-prime"
            title="Tempo Order" v-model="$parent.addTempoOrderDrawer" width="500">
        <div slot="header">
            <strong>Start Day</strong>
        </div>
        <Form :model="tempoOrderForm" :rules="ruleTempoOrderForm" label-position="top" ref="tempoOrderForm">
            <Row :gutter="10">

              <FormItem label="Date" prop="date">
                <DatePicker type="date" v-model="tempoOrderForm.date"
                            placeholder="Booking Date" format="dd/MM/yyyy" style="width: 264px"></DatePicker>
              </FormItem>

              <Col span="12">
                <FormItem prop="city" label="City">
                  <AutoComplete v-model="tempoOrderForm.city" v-if="$parent.addTempoOrderDrawer"
                                @on-search="handleCitySearch" @on-focus="cityFilter='%%'">
                    <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                            :key="index" :value="cityObj.city">
                      <div class="ivu-select-item-div" @click="onSelectCity(cityObj)">{{cityObj.city}}</div>
                    </Option>
                  </AutoComplete>
                </FormItem>
              </Col>

                <Col span="24">
                    <FormItem prop="contractorName" label="Contractor">
                        <Select v-model="tempoOrderForm.contractorName" filterable>
                            <Option v-for="(contractor, index) in contractorArr" :value="contractor.name"
                                    :label="contractor.name" :key="index">
                                <div class="ivu-select-item-div" @click="onSelectContractor(contractor)"> {{contractor.name}}
                                    <span style="float: right;color:#C0C0C0">{{contractor.contractorCode}}</span></div>
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24" >
                    <FormItem prop="tempoName" label="Tempo">
                        <Select v-model="tempoOrderForm.tempoName" filterable>
<!--                            <Option v-for="(tempo, index) in editMode?tempoArr_inEditMode:tempoArr" :value="tempo.platNo"-->
                            <Option v-for="(tempo, index) in tempoArr" :value="tempo.platNo"
                                    :label="tempo.platNo" :key="index">
                                <div class="ivu-select-item-div"
                                     @click="tempoOrderForm.tempoId=tempo.id">{{tempo.platNo}} </div>
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="24">
                    <FormItem prop="driverName" label="Driver">
                        <Select v-model="tempoOrderForm.driverName" filterable>
<!--                            <Option v-for="(driver, index) in editMode?driverArr_inEditMode:driverArr" :value="driver.name"-->
                            <Option v-for="(driver, index) in driverArr" :value="driver.name"
                                    :label="driver.name" :key="index">
                                <div class="ivu-select-item-div"
                                     @click="tempoOrderForm.driverId=driver.id">{{driver.name}} </div>
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="startReading" label="Start Reading">
                        <Input type="number" v-model="tempoOrderForm.startReading" suffix="md-speedometer"/>
                    </FormItem>
                </Col>
<!--                <Col span="12">-->
<!--                    <FormItem prop="endReading" label="End Reading">-->
<!--                        <Input v-model="tempoOrderForm.endReading" readonly suffix="md-speedometer"/>-->
<!--                    </FormItem>-->
<!--                </Col>-->
                <Col span="24">
                    <!--<Button v-show="!editMode" @click="addTempoOrder" type="primary">Start Day</Button>-->
                    <Button v-show="!editMode" @click="addTempoOrder" type="primary" :loading="loading">
                        <span v-if="!loading">Start Day</span>
                        <span v-else>Loading...</span>
                    </Button>
                    <Button v-show="editMode" @click="modifyTempoOrder" type="primary">Update</Button>
                </Col>

            </Row>
        </Form>

    </Drawer>
</template>

<script>
  import {
    GET_CONTRACTORS,
    GET_UNOCCUPIED_TEMPOS,
    GET_UNOCCUPIED_TEMPO_DRIVERS,
    GET_CONTRACTORS_BY_CITY
  } from '../../graphql/queries/vehicle'
  import {SUBSCRIBE_CONTRACTORS, SUBSCRIBE_CONTRACTORS_BY_CITY} from '../../graphql/subscription/vehicle'
import {GET_LAST_TEMPO_ORDER_CODE} from '../../graphql/queries/tempoOrders'
import {ADD_TEMPO_ORDER, DELETE_TEMPO_ORDER, UPDATE_TEMPO_ORDER} from '../../graphql/mutations/tempoOrders'
import {generateUUID} from "../../Constants/Constant";
import ValidationRules from '../../Constants/ValidationRules'
import moment from 'moment'
import { SEARCH_CITY2} from '../../graphql/queries/territories'
import _ from "lodash";
import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";
    export default {
        apollo: {
            contractor: {
                query: GET_CONTRACTORS_BY_CITY,
                skip: true,
                variables(){return { selectedCity: this.selectedCity }},
                subscribeToMore: {
                    document: SUBSCRIBE_CONTRACTORS_BY_CITY,
                    variables(){return { selectedCity: this.selectedCity }},
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.contractorArr = subscriptionData.data.contractor;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.contractorArr = data.contractor;
                    }
                }
            },
            unOccupiedTempos: {
                query: GET_UNOCCUPIED_TEMPOS,
                variables(){
                    return {
                        tempoIds: this.$parent.occupiedTempoIdArr,
                        contractorId: this.tempoOrderForm.contractorId
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.tempoArr = data.unOccupiedTempos;
                    }
                }
            },
            unOccupiedDrivers: {
                query: GET_UNOCCUPIED_TEMPO_DRIVERS,
                variables(){
                    return {
                        driverIds: this.$parent.occupiedDriverIdArr,
                        contractorId: this.tempoOrderForm.contractorId
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.driverArr = data.unOccupiedDrivers;
                    }
                }
            },
            city: {
              query: SEARCH_CITY2,
              variables() {
                return {
                  cityFilter: this.cityFilter
                }
              },
              result ({ data, loading }) {
                if (!loading) {
                  this.cityArr = data.city;
                }
              }
            }
        },
        name: "AddTempoOrder",
        data: function(){
            return {
                mutation_ADD_TEMPO_ORDER: ADD_TEMPO_ORDER,
                mutation_UPDATE_TEMPO_ORDER: UPDATE_TEMPO_ORDER,
                moment: moment,
                tempoOrderForm:{
                    id: '',
                    contractorId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                    contractorName: '',
                    contractorCode: '',
                    tempoId: '',
                    tempoName: '',
                    driverId: '',
                    driverName: '',
                    startReading: '',
                    endReading: '',
                    city: '',
                    date: moment().format('DD/MM/YYYY')
                },
                ruleTempoOrderForm: {
                    contractorName: ValidationRules.selectField,
                    tempoName: ValidationRules.selectField,
                    driverName: ValidationRules.selectField,
                    startReading: ValidationRules.numberField,
                    city: ValidationRules.textField('City'),
                },
                cityFilter: '%%',
                cityArr: [],
                contractorArr: [],
                tempoArr: [],
                driverArr: [],
                tempoArr_inEditMode: [],
                driverArr_inEditMode: [],
                editMode: false,
                lastTempoOrderCode: 'TM-MOR-20191122000',
                cityCode: 'MRB',
                loading: false,
                selectedCity: ''
            }
        },
        methods: {
            onSelectCity(cityObj){
              this.cityCode = cityObj.shortCode;
              this.selectedCity = cityObj.city;
              this.$apollo.queries.contractor.skip = false;
            },
            async onSelectContractor(contractor){
                this.tempoOrderForm.contractorId = contractor.id
                this.tempoOrderForm.contractorCode = contractor.contractorCode
            },
            reset: function(){
                this.$refs['tempoOrderForm'].resetFields();
                this.contractorArr = []
                this.$apollo.queries.contractor.skip = true;
            },
            handleCitySearch: _.debounce(function(val){
              this.cityFilter = '%' + val + '%'
            }, 500),
            setTempoOrderForm(tempoOrderData){
                this.tempoArr_inEditMode = JSON.parse(JSON.stringify(this.tempoArr));
                this.tempoArr_inEditMode.push({id: tempoOrderData.tempoId, name: tempoOrderData.tempo.name, platNo:tempoOrderData.tempo.platNo})
                this.driverArr_inEditMode = JSON.parse(JSON.stringify(this.driverArr));
                this.driverArr_inEditMode.push({id: tempoOrderData.driverId, name: tempoOrderData.driverDetail.name})
                this.tempoOrderForm.id = tempoOrderData.id;
                this.tempoOrderForm.contractorId = tempoOrderData.contractorId;
                this.tempoOrderForm.contractorName = tempoOrderData.contractor.name;
                this.tempoOrderForm.contractorCode = tempoOrderData.contractorCode;
                this.cityCode = tempoOrderData.City?.shortCode||'';
                this.tempoOrderForm.city = tempoOrderData?.city||'';
                this.tempoOrderForm.tempoId = tempoOrderData.tempoId;
                this.tempoOrderForm.tempoName = tempoOrderData.tempo.platNo;
                this.tempoOrderForm.driverId = tempoOrderData.driverId;
                this.tempoOrderForm.driverName = tempoOrderData.driverDetail.name;
                this.tempoOrderForm.startReading = tempoOrderData.startReading;
                this.tempoOrderForm.endReading = tempoOrderData.endReading;
                this.tempoOrderForm.date = moment(tempoOrderData.date, 'YYYY-MM-DD').format('DD/MM/YYYY')

                this.selectedCity = tempoOrderData?.city||'';
                this.$apollo.queries.contractor.skip = false;
            },
            addTempoOrder(){
                this.loading = true
                this.$refs['tempoOrderForm'].validate((valid) => {
                    if (valid) {
                        this.insertTempoOrder();
                    }else{
                        this.loading = false
                    }
                })
            },
            generateTempoOrderCode(){
                let lastThreeDigits = parseInt(this.lastTempoOrderCode.substr(this.lastTempoOrderCode.length - 3)) + 1;
                if(lastThreeDigits.toString().length == 1){
                    lastThreeDigits = '00' + lastThreeDigits
                }else if(lastThreeDigits.toString().length == 2){
                    lastThreeDigits = '0' + lastThreeDigits
                }
                return 'TM-' + this.cityCode + '-' + moment().format('YYYYMMDD') + lastThreeDigits;
            },
            async insertTempoOrder(){

              /* ---------- GET LAST TEMPO ORDER NUMBER ------------ */
              let res = await this.$apollo.query({
                query: GET_LAST_TEMPO_ORDER_CODE,
                variables: {
                  todayDate: moment().format('YYYY-MM-DD')
                },
                fetchPolicy: "network-only"
              })
              if(res.data.lastTempoOrder.length){
                this.lastTempoOrderCode = res.data.lastTempoOrder[0].tempoOrderCode;
              }
              let tempoOrderCode = this.generateTempoOrderCode()
              /* ---------------x---------------x--------------x------------ */

                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_TEMPO_ORDER,
                    variables: {
                        id: generateUUID(),
                        tempoOrderCode: tempoOrderCode,
                        contractorId: this.tempoOrderForm.contractorId,
                        contractorCode: this.tempoOrderForm.contractorCode,
                        tempoId: this.tempoOrderForm.tempoId,
                        driverId: this.tempoOrderForm.driverId,
                        date: moment(this.tempoOrderForm.date, 'ddd MMMM DD YYYY').format('YYYY-MM-DD'),
                        city: this.tempoOrderForm.city,
                        startReading: this.tempoOrderForm.startReading,
                        endReading: this.tempoOrderForm.endReading,
                        createdAt: moment().format()
                    }
                })
                if(response.data.insert_tempoOrders.returning[0].id){
                    this.$Message.success('Tempo Order placed successfully!');
                    this.reset();
                    this.loading = false
                    this.$parent.addTempoOrderDrawer = false;
                }
            },
            modifyTempoOrder(){
                this.$refs['tempoOrderForm'].validate((valid) => {
                    if (valid) {
                        this.updateTempoOrder();
                    }
                })
            },
            async updateTempoOrder(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_TEMPO_ORDER,
                    variables: {
                        tempoOrderId: this.tempoOrderForm.id,
                        contractorId: this.tempoOrderForm.contractorId,
                        contractorCode: this.tempoOrderForm.contractorCode,
                        tempoId: this.tempoOrderForm.tempoId,
                        driverId: this.tempoOrderForm.driverId,
                        city: this.tempoOrderForm.city,
                        startReading: this.tempoOrderForm.startReading,
                        endReading: this.tempoOrderForm.endReading,
                        date: moment(this.tempoOrderForm.date, 'ddd MMMM DD YYYY').format('YYYY-MM-DD'),
                    }
                })
                if(response.data){
                    this.$Message.success('Tempo Order updated successfully!');
                    this.reset();
                    this.$parent.addTempoOrderDrawer = false;
                }
            },
            onDeleteTempoOrder(id){
              this.$Modal.confirm({
                title: 'Confirmation',
                content: '<p>Are You sure want to delete Tempo Order ?</p>',
                loading: true,
                onOk: () => {
                  // this.deleteTempoOrder(id, this.$Modal)
                  let obj = {status: 'Cancel'}
                  this.updateRecord(id, obj, 'tempoOrders', this.$Modal)
                }
              });
            },
            async updateRecord(id, obj, table, callback){
              let response = await this.$apollo.mutate({
                mutation: generate_UPDATE_ORDER_DATA(table),
                variables: { id: id, obj: obj}
              })
              if(response.data){
                this.$Message.success('Tempo Order updated successfully!')
                callback.remove();
              }
            },
        }
    }
</script>

<style scoped>
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }
    /deep/ .ivu-date-picker-cells{
      width: 259px !important;
    }
    /deep/ .ivu-date-picker-cells span{
      width: 37px !important;
      margin: 0;
      font-size: 15px;
    }
</style>
